import React, { useEffect, useRef } from 'react';
import classNames                   from 'classnames';
import { useTranslation }           from 'react-i18next';

import CompareModalIcon    from '../icons/CompareModalIcon';
import { useCompareModal } from '../../providers/compareModal';

const CompareModal = function() {
  const {
          comparisonLabel,
          door,
          hideCompareModal,
          open,
        } = useCompareModal();

  const { t } = useTranslation();

  const modalRef = useRef();

  useEffect(() => {
    if (open) {
      const timer = setTimeout(() => {
        hideCompareModal();
      }, 3000);

      return () => {
        clearTimeout(timer);
      };
    }
  }, [open, hideCompareModal]);

  return (
    <div
      className={classNames('modal-overlay', 'сompare_modal_overlay', {
        show: open,
      })}
    >
      <div className={classNames('modal', 'сompare_modal')} ref={modalRef}>
        <CompareModalIcon />
        <p>{t('client_compare.door')}{' '}<span>{door}</span>{' '}{comparisonLabel}</p>
      </div>
    </div>
  );
};

export default CompareModal;